export const backendData = {
  id: 'backend',
  title: 'Backend Developer',
  icon: 'Server',
  color: 'from-accent to-blue-600',
  description: 'Recursos de desarrollo, APIs, frameworks y herramientas',
  categories: [
    {
      name: 'Frameworks & Lenguajes',
      icon: 'Code',
      resources: [
        {
          id: 'laravel-1',
          title: 'Laravel 10 - Guía Completa',
          type: 'Documentación',
          description: 'Guía completa de Laravel 10 con ejemplos prácticos, desde la instalación hasta el despliegue en producción. Incluye patrones de diseño, testing y mejores prácticas.',
          tags: ['Laravel', 'PHP', 'Framework'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-15',
          author: 'Equipo Backend',
          downloads: 156,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Instalación y Configuración',
                content: 'Configuración del entorno de desarrollo, instalación de Composer y Laravel, configuración de base de datos y variables de entorno.',
                subsections: [
                  'Requisitos del sistema',
                  'Instalación de Composer',
                  'Creación del proyecto Laravel',
                  'Configuración de .env'
                ]
              },
              {
                title: 'Arquitectura MVC',
                content: 'Entendimiento del patrón Model-View-Controller en Laravel, estructura de directorios y flujo de datos.',
                subsections: [
                  'Estructura de directorios',
                  'Controllers y métodos',
                  'Models y Eloquent',
                  'Views y Blade templates'
                ]
              },
              {
                title: 'Eloquent ORM',
                content: 'Uso avanzado de Eloquent para operaciones de base de datos, relaciones, scopes y mutators.',
                subsections: [
                  'Definición de modelos',
                  'Relaciones entre modelos',
                  'Query builders',
                  'Migrations y seeders'
                ]
              },
              {
                title: 'Autenticación y Autorización',
                content: 'Sistema de autenticación integrado, middleware de autorización y gestión de roles y permisos.',
                subsections: [
                  'Sistema de login',
                  'Middleware de autenticación',
                  'Gates y Policies',
                  'Roles y permisos'
                ]
              },
              {
                title: 'APIs RESTful',
                content: 'Creación de APIs RESTful con Laravel, validación de datos, respuestas JSON y documentación.',
                subsections: [
                  'API Resources',
                  'Validación de requests',
                  'Transformación de respuestas',
                  'API versioning'
                ]
              },
              {
                title: 'Testing con PHPUnit',
                content: 'Estrategias de testing, unit tests, feature tests y testing de APIs.',
                subsections: [
                  'Configuración de PHPUnit',
                  'Unit tests',
                  'Feature tests',
                  'Database testing'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Laravel-10-Guia-Completa.pdf',
              type: 'application/pdf',
              size: 2048576
            },
            {
              name: 'ejemplos-laravel.zip',
              type: 'application/zip',
              size: 1048576
            }
          ],
          externalLinks: [
            {
              title: 'Documentación Oficial Laravel',
              description: 'Documentación completa y actualizada de Laravel 10',
              url: 'https://laravel.com/docs'
            }
          ]
        },
        {
          id: 'node-1',
          title: 'Node.js - Patrones de Diseño',
          type: 'Guía',
          description: 'Patrones de diseño comunes en Node.js y mejores prácticas para aplicaciones escalables y mantenibles.',
          tags: ['Node.js', 'JavaScript', 'Patrones'],
          difficulty: 'Avanzado',
          estimatedTime: '3h',
          lastUpdated: '2024-01-10',
          author: 'Senior Dev Team',
          downloads: 89,
          rating: 4.9,
          content: {
            sections: [
              {
                title: 'Singleton Pattern',
                content: 'Implementación del patrón Singleton en Node.js, casos de uso y consideraciones de performance.',
                subsections: [
                  'Implementación básica',
                  'Lazy initialization',
                  'Thread safety',
                  'Casos de uso reales'
                ]
              },
              {
                title: 'Factory Pattern',
                content: 'Uso del patrón Factory para crear objetos de manera flexible y desacoplada.',
                subsections: [
                  'Simple Factory',
                  'Factory Method',
                  'Abstract Factory',
                  'Ejemplos prácticos'
                ]
              },
              {
                title: 'Observer Pattern',
                content: 'Implementación del patrón Observer con EventEmitter y casos de uso en aplicaciones Node.js.',
                subsections: [
                  'EventEmitter nativo',
                  'Custom EventEmitter',
                  'Pub/Sub pattern',
                  'Event-driven architecture'
                ]
              },
              {
                title: 'Middleware Pattern',
                content: 'Patrón de middleware para procesamiento de requests y responses en aplicaciones web.',
                subsections: [
                  'Express middleware',
                  'Custom middleware',
                  'Error handling',
                  'Composición de middleware'
                ]
              },
              {
                title: 'Repository Pattern',
                content: 'Separación de la lógica de acceso a datos y abstracción de la capa de persistencia.',
                subsections: [
                  'Interfaces de repositorio',
                  'Implementaciones concretas',
                  'Testing con mocks',
                  'Inyección de dependencias'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Node.js Best Practices',
              description: 'Guía de mejores prácticas para Node.js',
              url: 'https://github.com/goldbergyoni/nodebestpractices'
            }
          ]
        },
        {
          id: 'python-1',
          title: 'FastAPI - APIs de Alto Rendimiento',
          type: 'Tutorial',
          description: 'Creación de APIs REST con FastAPI y Python, incluyendo validación automática, documentación y testing.',
          tags: ['Python', 'FastAPI', 'API'],
          difficulty: 'Intermedio',
          estimatedTime: '1.5h',
          lastUpdated: '2024-01-20',
          author: 'Python Team',
          downloads: 234,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Configuración del Proyecto',
                content: 'Setup inicial del proyecto FastAPI, instalación de dependencias y configuración del entorno.',
                subsections: [
                  'Instalación de FastAPI',
                  'Uvicorn server',
                  'Estructura del proyecto',
                  'Dependencias requeridas'
                ]
              },
              {
                title: 'Modelos Pydantic',
                content: 'Uso de Pydantic para validación de datos, serialización y documentación automática.',
                subsections: [
                  'Definición de modelos',
                  'Validación de tipos',
                  'Custom validators',
                  'Serialización'
                ]
              },
              {
                title: 'Endpoints y Validación',
                content: 'Creación de endpoints RESTful con validación automática de parámetros y body.',
                subsections: [
                  'Path parameters',
                  'Query parameters',
                  'Request body',
                  'Response models'
                ]
              },
              {
                title: 'Autenticación JWT',
                content: 'Implementación de autenticación JWT con FastAPI y manejo de usuarios.',
                subsections: [
                  'JWT tokens',
                  'Dependencias de seguridad',
                  'User management',
                  'Protected routes'
                ]
              },
              {
                title: 'Documentación Automática',
                content: 'Generación automática de documentación OpenAPI y Swagger UI.',
                subsections: [
                  'OpenAPI specification',
                  'Swagger UI',
                  'ReDoc',
                  'Custom documentation'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'FastAPI-Tutorial.pdf',
              type: 'application/pdf',
              size: 1536000
            }
          ]
        }
      ]
    },
    {
      name: 'Testing & Calidad',
      icon: 'Shield',
      resources: [
        {
          id: 'testing-1',
          title: 'Unit Testing - Guía Completa',
          type: 'Guía',
          description: 'Estrategias y mejores prácticas para unit testing, incluyendo frameworks, patrones y métricas de calidad.',
          tags: ['Testing', 'Unit Tests', 'Calidad'],
          difficulty: 'Intermedio',
          estimatedTime: '2.5h',
          lastUpdated: '2024-01-12',
          author: 'QA Team',
          downloads: 178,
          rating: 4.6,
          content: {
            sections: [
              {
                title: 'Principios de Testing',
                content: 'Fundamentos del testing, principios FIRST y estrategias para escribir tests efectivos.',
                subsections: [
                  'FIRST principles',
                  'Arrange-Act-Assert',
                  'Test isolation',
                  'Deterministic tests'
                ]
              },
              {
                title: 'Frameworks de Testing',
                content: 'Comparación de frameworks populares y selección del más apropiado para cada proyecto.',
                subsections: [
                  'Jest para JavaScript',
                  'PHPUnit para PHP',
                  'Pytest para Python',
                  'NUnit para .NET'
                ]
              },
              {
                title: 'Mocking y Stubbing',
                content: 'Técnicas de mocking para aislar unidades de código y simular dependencias externas.',
                subsections: [
                  'Mock objects',
                  'Stub methods',
                  'Spy functions',
                  'Fake implementations'
                ]
              },
              {
                title: 'Test Coverage',
                content: 'Métricas de cobertura de código y estrategias para mejorar la calidad de los tests.',
                subsections: [
                  'Line coverage',
                  'Branch coverage',
                  'Function coverage',
                  'Coverage goals'
                ]
              },
              {
                title: 'TDD y BDD',
                content: 'Metodologías Test-Driven Development y Behavior-Driven Development.',
                subsections: [
                  'Red-Green-Refactor',
                  'User stories',
                  'Gherkin syntax',
                  'Living documentation'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Testing Best Practices',
              description: 'Guía completa de mejores prácticas en testing',
              url: 'https://github.com/goldbergyoni/javascript-testing-best-practices'
            }
          ]
        },
        {
          id: 'testing-2',
          title: 'PHPUnit - Casos de Uso Reales',
          type: 'Ejemplos',
          description: 'Ejemplos prácticos de testing con PHPUnit en Laravel, incluyendo testing de diferentes capas de la aplicación.',
          tags: ['PHPUnit', 'Laravel', 'Testing'],
          difficulty: 'Intermedio',
          estimatedTime: '1h',
          lastUpdated: '2024-01-18',
          author: 'Backend Team',
          downloads: 145,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Testing de Controllers',
                content: 'Estrategias para testing de controllers, mocking de requests y validación de responses.',
                subsections: [
                  'Request mocking',
                  'Response assertions',
                  'Middleware testing',
                  'Authentication testing'
                ]
              },
              {
                title: 'Testing de Models',
                content: 'Testing de modelos Eloquent, relaciones y métodos personalizados.',
                subsections: [
                  'Model factories',
                  'Relationship testing',
                  'Custom methods',
                  'Validation testing'
                ]
              },
              {
                title: 'Testing de Services',
                content: 'Testing de servicios de negocio y lógica de aplicación.',
                subsections: [
                  'Service mocking',
                  'Business logic',
                  'Error handling',
                  'Integration testing'
                ]
              },
              {
                title: 'Testing de APIs',
                content: 'Testing de endpoints de API, validación de JSON responses y testing de autenticación.',
                subsections: [
                  'API testing',
                  'JSON validation',
                  'Status codes',
                  'Authentication'
                ]
              },
              {
                title: 'Database Testing',
                content: 'Testing de operaciones de base de datos con base de datos de testing.',
                subsections: [
                  'Test database',
                  'Migrations',
                  'Seeders',
                  'Transactions'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'PHPUnit-Ejemplos.zip',
              type: 'application/zip',
              size: 512000
            }
          ]
        }
      ]
    },
    {
      name: 'Arquitectura',
      icon: 'Building',
      resources: [
        {
          id: 'arch-1',
          title: 'Arquitectura Hexagonal',
          type: 'Documentación',
          description: 'Implementación de arquitectura hexagonal en aplicaciones backend, principios y patrones de implementación.',
          tags: ['Arquitectura', 'Clean Code', 'DDD'],
          difficulty: 'Avanzado',
          estimatedTime: '4h',
          lastUpdated: '2024-01-05',
          author: 'Architecture Team',
          downloads: 67,
          rating: 4.9,
          content: {
            sections: [
              {
                title: 'Conceptos Fundamentales',
                content: 'Principios básicos de la arquitectura hexagonal, separación de responsabilidades y dependencias.',
                subsections: [
                  'Ports y Adapters',
                  'Domain isolation',
                  'Dependency inversion',
                  'Clean architecture'
                ]
              },
              {
                title: 'Ports y Adapters',
                content: 'Implementación de ports (interfaces) y adapters (implementaciones) para desacoplar capas.',
                subsections: [
                  'Input ports',
                  'Output ports',
                  'Primary adapters',
                  'Secondary adapters'
                ]
              },
              {
                title: 'Domain Layer',
                content: 'Capa de dominio con entidades, value objects y reglas de negocio.',
                subsections: [
                  'Entities',
                  'Value Objects',
                  'Domain Services',
                  'Business Rules'
                ]
              },
              {
                title: 'Application Layer',
                content: 'Capa de aplicación con casos de uso y orquestación de servicios.',
                subsections: [
                  'Use Cases',
                  'Application Services',
                  'Command/Query',
                  'Event handling'
                ]
              },
              {
                title: 'Infrastructure Layer',
                content: 'Implementaciones concretas de adapters para bases de datos, APIs externas y servicios.',
                subsections: [
                  'Database adapters',
                  'External API adapters',
                  'Message queues',
                  'File systems'
                ]
              },
              {
                title: 'Testing de Arquitectura',
                content: 'Estrategias para testing de arquitectura hexagonal y validación de dependencias.',
                subsections: [
                  'Unit testing',
                  'Integration testing',
                  'Architecture testing',
                  'Dependency validation'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Clean Architecture',
              description: 'Principios de Clean Architecture por Robert C. Martin',
              url: 'https://blog.cleancoder.com/uncle-bob/2012/08/13/the-clean-architecture.html'
            }
          ]
        },
        {
          id: 'arch-2',
          title: 'Microservicios - Patrones y Prácticas',
          type: 'Guía',
          description: 'Diseño e implementación de microservicios, patrones de comunicación y estrategias de escalabilidad.',
          tags: ['Microservicios', 'Arquitectura', 'Escalabilidad'],
          difficulty: 'Avanzado',
          estimatedTime: '3.5h',
          lastUpdated: '2024-01-08',
          author: 'Senior Architects',
          downloads: 123,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Diseño de Servicios',
                content: 'Principios de diseño de microservicios, bounded contexts y granularidad apropiada.',
                subsections: [
                  'Service boundaries',
                  'Bounded contexts',
                  'Service granularity',
                  'Domain modeling'
                ]
              },
              {
                title: 'Comunicación entre Servicios',
                content: 'Patrones de comunicación síncrona y asíncrona entre microservicios.',
                subsections: [
                  'REST APIs',
                  'Message queues',
                  'Event-driven',
                  'Synchronous vs Async'
                ]
              },
              {
                title: 'Service Discovery',
                content: 'Mecanismos de descubrimiento de servicios y balanceo de carga.',
                subsections: [
                  'Service registry',
                  'Load balancing',
                  'Health checks',
                  'Circuit breakers'
                ]
              },
              {
                title: 'Circuit Breaker Pattern',
                content: 'Implementación del patrón circuit breaker para manejo de fallos y resiliencia.',
                subsections: [
                  'Circuit states',
                  'Failure thresholds',
                  'Recovery strategies',
                  'Monitoring'
                ]
              },
              {
                title: 'Distributed Tracing',
                content: 'Técnicas para tracing distribuido y monitoreo de microservicios.',
                subsections: [
                  'Trace propagation',
                  'Span correlation',
                  'Performance analysis',
                  'Error tracking'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Microservicios-Patrones.pdf',
              type: 'application/pdf',
              size: 3072000
            }
          ]
        }
      ]
    },
    {
      name: 'APIs & Integración',
      icon: 'Globe',
      resources: [
        {
          id: 'api-1',
          title: 'API REST - Mejores Prácticas',
          type: 'Estándares',
          description: 'Estándares y mejores prácticas para diseño de APIs REST, incluyendo convenciones, versionado y documentación.',
          tags: ['API', 'REST', 'Estándares'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-14',
          author: 'API Team',
          downloads: 298,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Convenciones de Nomenclatura',
                content: 'Convenciones estándar para URLs, métodos HTTP y respuestas en APIs REST.',
                subsections: [
                  'URL naming',
                  'HTTP methods',
                  'Status codes',
                  'Response formats'
                ]
              },
              {
                title: 'HTTP Status Codes',
                content: 'Uso apropiado de códigos de estado HTTP y manejo de errores.',
                subsections: [
                  '2xx Success',
                  '4xx Client errors',
                  '5xx Server errors',
                  'Custom status codes'
                ]
              },
              {
                title: 'Versionado de APIs',
                content: 'Estrategias para versionado de APIs y compatibilidad hacia atrás.',
                subsections: [
                  'URL versioning',
                  'Header versioning',
                  'Content negotiation',
                  'Deprecation strategies'
                ]
              },
              {
                title: 'Documentación con OpenAPI',
                content: 'Documentación automática de APIs usando OpenAPI/Swagger specification.',
                subsections: [
                  'OpenAPI spec',
                  'Swagger UI',
                  'Code generation',
                  'Interactive docs'
                ]
              },
              {
                title: 'Rate Limiting',
                content: 'Implementación de rate limiting para proteger APIs de abuso y sobrecarga.',
                subsections: [
                  'Token bucket',
                  'Leaky bucket',
                  'Fixed window',
                  'Sliding window'
                ]
              },
              {
                title: 'Error Handling',
                content: 'Estrategias para manejo consistente de errores en APIs REST.',
                subsections: [
                  'Error formats',
                  'Validation errors',
                  'Business logic errors',
                  'System errors'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'REST API Design Guidelines',
              description: 'Guía completa de diseño de APIs REST',
              url: 'https://github.com/microsoft/api-guidelines'
            }
          ]
        },
        {
          id: 'api-2',
          title: 'GraphQL vs REST',
          type: 'Comparación',
          description: 'Análisis comparativo entre GraphQL y REST APIs, ventajas, desventajas y casos de uso apropiados.',
          tags: ['GraphQL', 'REST', 'API'],
          difficulty: 'Intermedio',
          estimatedTime: '1.5h',
          lastUpdated: '2024-01-16',
          author: 'Full Stack Team',
          downloads: 167,
          rating: 4.6,
          content: {
            sections: [
              {
                title: 'Ventajas de GraphQL',
                content: 'Beneficios de GraphQL incluyendo flexibilidad en queries, over-fetching y under-fetching.',
                subsections: [
                  'Flexible queries',
                  'Single endpoint',
                  'Real-time updates',
                  'Strong typing'
                ]
              },
              {
                title: 'Ventajas de REST',
                content: 'Beneficios de REST incluyendo simplicidad, caching y herramientas maduras.',
                subsections: [
                  'Simplicidad',
                  'HTTP caching',
                  'Mature tooling',
                  'Stateless design'
                ]
              },
              {
                title: 'Casos de Uso',
                content: 'Análisis de cuándo usar cada tecnología según los requerimientos del proyecto.',
                subsections: [
                  'Mobile apps',
                  'Public APIs',
                  'Internal APIs',
                  'Real-time apps'
                ]
              },
              {
                title: 'Performance',
                content: 'Comparación de performance entre GraphQL y REST en diferentes escenarios.',
                subsections: [
                  'Query complexity',
                  'Caching strategies',
                  'Network overhead',
                  'Server load'
                ]
              },
              {
                title: 'Implementación',
                content: 'Consideraciones técnicas para implementar GraphQL vs REST en proyectos reales.',
                subsections: [
                  'Learning curve',
                  'Team expertise',
                  'Infrastructure',
                  'Maintenance'
                ]
              }
            ]
          }
        }
      ]
    },
    {
      name: 'Base de Datos',
      icon: 'Database',
      resources: [
        {
          id: 'db-1',
          title: 'SQL Avanzado - Optimización',
          type: 'Guía',
          description: 'Técnicas de optimización y consultas SQL avanzadas para mejorar el performance de bases de datos.',
          tags: ['SQL', 'Database', 'Optimización'],
          difficulty: 'Avanzado',
          estimatedTime: '2.5h',
          lastUpdated: '2024-01-11',
          author: 'DBA Team',
          downloads: 134,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Índices y Performance',
                content: 'Estrategias de indexación para optimizar consultas y mejorar el rendimiento de bases de datos.',
                subsections: [
                  'Tipos de índices',
                  'Composite indexes',
                  'Index selectivity',
                  'Index maintenance'
                ]
              },
              {
                title: 'Query Optimization',
                content: 'Técnicas para optimizar consultas SQL y analizar planes de ejecución.',
                subsections: [
                  'EXPLAIN plans',
                  'Query rewriting',
                  'Join optimization',
                  'Subquery optimization'
                ]
              },
              {
                title: 'Stored Procedures',
                content: 'Uso de stored procedures para encapsular lógica de negocio y mejorar performance.',
                subsections: [
                  'Procedure design',
                  'Parameter handling',
                  'Error handling',
                  'Performance benefits'
                ]
              },
              {
                title: 'Triggers',
                content: 'Implementación de triggers para automatizar acciones en bases de datos.',
                subsections: [
                  'Trigger types',
                  'Before/After triggers',
                  'Trigger logic',
                  'Performance considerations'
                ]
              },
              {
                title: 'Transactions y ACID',
                content: 'Propiedades ACID de las transacciones y manejo de concurrencia.',
                subsections: [
                  'Atomicity',
                  'Consistency',
                  'Isolation levels',
                  'Deadlock handling'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'SQL-Optimizacion.pdf',
              type: 'application/pdf',
              size: 1792000
            }
          ]
        },
        {
          id: 'db-2',
          title: 'MongoDB - NoSQL en Producción',
          type: 'Tutorial',
          description: 'Implementación y mantenimiento de MongoDB en producción, incluyendo configuración, monitoreo y backup.',
          tags: ['MongoDB', 'NoSQL', 'Database'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-19',
          author: 'NoSQL Team',
          downloads: 89,
          rating: 4.5,
          content: {
            sections: [
              {
                title: 'Configuración de Cluster',
                content: 'Configuración de clusters de MongoDB para alta disponibilidad y escalabilidad.',
                subsections: [
                  'Replica sets',
                  'Sharding',
                  'Load balancing',
                  'Network configuration'
                ]
              },
              {
                title: 'Sharding',
                content: 'Implementación de sharding para distribuir datos y mejorar performance.',
                subsections: [
                  'Shard key selection',
                  'Chunk distribution',
                  'Balancing',
                  'Shard management'
                ]
              },
              {
                title: 'Replicación',
                content: 'Configuración de replica sets para alta disponibilidad y disaster recovery.',
                subsections: [
                  'Primary-secondary',
                  'Election process',
                  'Failover',
                  'Read preferences'
                ]
              },
              {
                title: 'Backup y Recovery',
                content: 'Estrategias de backup y recovery para MongoDB en entornos de producción.',
                subsections: [
                  'Backup strategies',
                  'Point-in-time recovery',
                  'Disaster recovery',
                  'Testing procedures'
                ]
              },
              {
                title: 'Monitoring',
                content: 'Monitoreo de performance y salud de clusters de MongoDB.',
                subsections: [
                  'Performance metrics',
                  'Health checks',
                  'Alerting',
                  'Capacity planning'
                ]
              }
            ]
          }
        }
      ]
    }
  ]
};
